import {
  SENDPINBYSMS_SUCCESS,
  SENDPINBYSMS_FAILED,
  SENDPINBYSMS_INVALID_REQUEST,
  LOADING_SENDPINBYSMS,
  SENDPINBYSMS_NOTFOUND,
  RESET_SENDPINBYSMS
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  status: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SENDPINBYSMS:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        status: {}
      };
    case SENDPINBYSMS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        status: action.payload.status
      };

    case SENDPINBYSMS_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case SENDPINBYSMS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case SENDPINBYSMS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        status: action.payload.status
      };

    case RESET_SENDPINBYSMS:
      return (state = initialState);

    default:
      return state;
  }
};
